import { render } from "./AddPetNest.vue?vue&type=template&id=aae123e2&scoped=true"
import script from "./AddPetNest.vue?vue&type=script&lang=js"
export * from "./AddPetNest.vue?vue&type=script&lang=js"

import "./AddPetNest.vue?vue&type=style&index=0&id=aae123e2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aae123e2"]])

export default __exports__